import { destroyExternalCourseWatcherSaga } from './destroy.saga'
import { externalDestroyExternalCoursesSaga } from './destroyMany.saga'
import { editExternalCourseWatcherSaga } from './edit.saga'
import { getExternalCourseWatcherSaga } from './get.saga'
import { getAdminExternalCourseWatcherSaga } from './getAdminExternalCourse.saga'
import { externalCoursesIndividualDownloadWatcherSaga } from './IndividualDownload.saga'
import { externalCoursesListAdministrationWatcherSaga } from './administration-list.saga'
import { publishExternalCourseWatcherSaga } from './publish.saga'
import { externalCourseUploadWatcherSaga } from './upload.saga'
import { uploadCertificatesExternalCoursesWatcherSaga } from './uploadCertificates.saga'
import { downloadExternalCourseWatcherSaga } from './download.saga'

export const root = [
  externalCoursesListAdministrationWatcherSaga(),
  editExternalCourseWatcherSaga(),
  getExternalCourseWatcherSaga(),
  destroyExternalCourseWatcherSaga(),
  publishExternalCourseWatcherSaga(),
  externalDestroyExternalCoursesSaga(),
  externalCoursesIndividualDownloadWatcherSaga(),
  getAdminExternalCourseWatcherSaga(),
  externalCourseUploadWatcherSaga(),
  uploadCertificatesExternalCoursesWatcherSaga(),
  downloadExternalCourseWatcherSaga()
]

export default root
